import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Formata o array de dados com as doses
 *
 * @param {*} cadastros
 * @returns {Array}
 */
export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes) ?? []

    let primeiraDoseFebreAmarela = encontrarDose(item, 'vfa', '1')
    let doseFebreAmarela = encontrarDose(item, 'vfa', '8')
    let dosesFebreAmarela =
      primeiraDoseFebreAmarela != undefined
        ? primeiraDoseFebreAmarela
        : doseFebreAmarela

    let primeiraDoseHepatiteA = encontrarDose(item, 'hepa_inf', '1')
    let unicaHepatiteA = encontrarDose(item, 'hepa_inf', '9')
    let doseHepatiteA =
      primeiraDoseHepatiteA != undefined
        ? primeiraDoseHepatiteA
        : unicaHepatiteA

    let objItem = {
      id: index,
      ...item,
      dosePneumococica: encontrarDose(item, 'vpc10', '2'),
      dosePneumococicaPendente: encontrarDosePendente(
        vacinasPendentes,
        '26',
        '2'
      ),
      doseRotaVirus: encontrarDose(item, 'rota', '2'),
      doseRotaVirusPendente: encontrarDosePendente(vacinasPendentes, '45', '2'),
      doseMeningococicaC: encontrarDose(item, 'menc', '2'),
      doseMeningococicaCPendente: encontrarDosePendente(
        vacinasPendentes,
        '41',
        '2'
      ),
      dosePenta: encontrarDose(item, 'penta', '3'),
      dosePentaPendente: encontrarDosePendente(vacinasPendentes, '42', '3'),
      doseVip: encontrarDose(item, 'vip', '3'),
      doseVipPendente: encontrarDosePendente(vacinasPendentes, '22', '3'),
      doseFebreAmarela: dosesFebreAmarela,
      doseFebreAmarelaPendente: encontrarDosePendente(
        vacinasPendentes,
        dosesFebreAmarela?.id_mn,
        dosesFebreAmarela?.id_ds
      ),
      doseHepatiteA: doseHepatiteA,
      doseHepatiteAPendente: encontrarDosePendente(
        vacinasPendentes,
        doseHepatiteA?.id_mn,
        doseHepatiteA?.id_ds
      ),
      doseTripliceViral: encontrarDose(item, 'scr', '1'),
      doseTripliceViralPendente: encontrarDosePendente(
        vacinasPendentes,
        '24',
        '1'
      ),
      cor: '',
    }

    let cor = ''
    const doses = [
      {
        dose: objItem.dosePneumococica,
        pendente: objItem.dosePneumococicaPendente,
        meses: 4,
      },
      {
        dose: objItem.doseRotaVirus,
        pendente: objItem.doseRotaVirusPendente,
        meses: 4,
      },
      {
        dose: objItem.doseMeningococicaC,
        pendente: objItem.doseMeningococicaCPendente,
        meses: 5,
      },
      {
        dose: objItem.dosePenta,
        pendente: objItem.dosePentaPendente,
        meses: 6,
      },
      { dose: objItem.doseVip, pendente: objItem.doseVipPendente, meses: 6 },
      {
        dose: objItem.doseFebreAmarela,
        pendente: objItem.doseFebreAmarelaPendente,
        meses: 9,
      },
      {
        dose: objItem.doseTripliceViral,
        pendente: objItem.doseTripliceViralPendente,
        meses: 12,
      },
      {
        dose: objItem.doseHepatiteA,
        pendente: objItem.doseHepatiteAPendente,
        meses: 15,
      },
    ]
    // Verificar se há alguma dose pendente
    const temDosePendente = doses.some(({ dose, pendente, meses }) => {
      let doseValida = pendente != null
      return doseValida
    })

    if (temDosePendente) {
      cor = 'red'
    } else {
      cor = 'green'
    }
    objItem.cor = cor

    return objItem
  })
  return data
}

/**
 * Procura a dose
 *
 * @param {Object} item
 * @param {String} vacina
 * @param {String} id_ds
 * @returns {Object|null}
 */
function encontrarDose(item, vacina, id_ds) {
  const raw = item?.[vacina]

  if (!raw) return null

  let vacinas = []
  try {
    vacinas = JSON.parse(raw) || []
  } catch (e) {
    return null
  }
  return vacinas.find((el) => el.id_ds === id_ds) || null
}

/**
 * Procura a dose pendente
 *
 * @param {Array} vacinasPendentes
 * @param {String} id_mn
 * @param {String} id_ds
 * @returns {Object|null}
 */
export function encontrarDosePendente(vacinasPendentes, id_mn, id_ds) {
  if (!Array.isArray(vacinasPendentes)) return null

  return (
    vacinasPendentes.find(
      (el) =>
        el.id_mn == id_mn &&
        el.id_ds == id_ds &&
        el.na == '0' &&
        el.ds_imnzt == '1'
    ) || null
  )
}

/**
 * Filtra os registros classificados como vermelhos.
 * @param {Array} cadastros Lista de registros
 * @returns {Array} Registros com dados desatualizados
 */
export function exibirVermelhos(cadastros) {
  const cadastrosComClasse = cadastros.map((item) => {
    const doses = [
      {
        dose: item.dosePneumococica,
        pendente: item.dosePneumococicaPendente,
        meses: 4,
      },
      {
        dose: item.doseRotaVirus,
        pendente: item.doseRotaVirusPendente,
        meses: 4,
      },
      {
        dose: item.doseMeningococicaC,
        pendente: item.doseMeningococicaCPendente,
        meses: 5,
      },
      { dose: item.dosePenta, pendente: item.dosePentaPendente, meses: 6 },
      { dose: item.doseVip, pendente: item.doseVipPendente, meses: 6 },
      {
        dose: item.doseFebreAmarela,
        pendente: item.doseFebreAmarelaPendente,
        meses: 9,
      },
      {
        dose: item.doseTripliceViral,
        pendente: item.doseTripliceViralPendente,
        meses: 12,
      },
      {
        dose: item.doseHepatiteA,
        pendente: item.doseHepatiteAPendente,
        meses: 15,
      },
    ]
    // Verificar se há alguma dose pendente
    const temDosePendente = doses.some(({ dose, pendente, meses }) => {
      let doseValida = pendente != null
      return doseValida
    })
    if (temDosePendente) {
      return {
        ...item,
        class: 'red',
      }
    }

    return {
      ...item,
      class: '',
    }
  })
  const filtro = cadastrosComClasse.filter((item) => item.class === 'red')

  return filtro
}

/**
 * Filtra os registros classificados como verdes.
 * @param {Array} cadastros Lista de registros
 * @returns {Array} Registros com dados atualizados
 */
export function exibirVerdes(cadastros) {
  const cadastrosComClasse = cadastros.map((item) => {
    const doses = [
      {
        dose: item.dosePneumococica,
        pendente: item.dosePneumococicaPendente,
        meses: 4,
      },
      {
        dose: item.doseRotaVirus,
        pendente: item.doseRotaVirusPendente,
        meses: 4,
      },
      {
        dose: item.doseMeningococicaC,
        pendente: item.doseMeningococicaCPendente,
        meses: 5,
      },
      { dose: item.dosePenta, pendente: item.dosePentaPendente, meses: 6 },
      { dose: item.doseVip, pendente: item.doseVipPendente, meses: 6 },
      {
        dose: item.doseFebreAmarela,
        pendente: item.doseFebreAmarelaPendente,
        meses: 9,
      },
      {
        dose: item.doseTripliceViral,
        pendente: item.doseTripliceViralPendente,
        meses: 12,
      },
      {
        dose: item.doseHepatiteA,
        pendente: item.doseHepatiteAPendente,
        meses: 15,
      },
    ]

    // Verificar se todas as doses pendentes estão null
    const todasDosesAplicadas = doses.every(({ dose, pendente, meses }) => {
      const doseValida = pendente == null
      return doseValida
    })
    if (todasDosesAplicadas) {
      return {
        ...item,
        class: 'green',
      }
    }

    return {
      ...item,
      class: '',
    }
  })

  const filtro = cadastrosComClasse.filter((item) => item.class === 'green')

  return filtro
}

/**
 * Filtra os registros classificados como pretos.
 * @param {Array} cadastros Lista de registros
 * @returns {Array}
 */
export function exibirPretos(cadastros) {
  let cadastrosFormatados = formatarCadastrosComDoses(cadastros).map((item) => {
    if (
      item.dosePneumococica?.dose_anterior === 1 ||
      item.doseRotaVirus?.dose_anterior === 1 ||
      item.doseMeningococicaC?.dose_anterior === 1 ||
      item.dosePenta?.dose_anterior === 1 ||
      item.doseVip?.dose_anterior === 1 ||
      item.doseFebreAmarela?.dose_anterior === 1 ||
      item.doseHepatiteA?.dose_anterior === 1 ||
      item.doseTripliceViral?.dose_anterior === 1
    ) {
      return {
        ...item,
        class: 'black',
      }
    }
    return {
      ...item,
      class: '',
    }
  })

  const filtro = cadastrosFormatados.filter((item) => item.class === 'black')

  return filtro
}

/**
 * Filtra os registros pela idade em meses.
 * @param {Array} data Lista de registros
 * @param {String|null} filter Idade selecionada (ex: "4 meses")
 * @returns {Array} Lista filtrada
 */
export function handleFilter(data, filter) {
  let filtrado = data.filter((item) => {
    if (filter === null) {
      return item
    }
    if (filter === '4 meses') {
      return Number(item.idade_meses) == 4
    } else if (filter === '5 meses') {
      return Number(item.idade_meses) == 5
    } else if (filter === '6 meses') {
      return Number(item.idade_meses) == 6
    } else if (filter === '9 meses') {
      return Number(item.idade_meses) == 9
    } else if (filter === '12 meses') {
      return Number(item.idade_meses) == 12
    } else if (filter === '15 meses') {
      return Number(item.idade_meses) == 15
    } else {
      return item
    }
  })
  return filtrado
}

/**
 * Gera o relatório em PDF.
 *
 * @param {Array} cadastros
 * @param {Object} selectEquipe
 * @param {String} microArea
 */

export function generatePdf(cadastros, selectEquipe, microArea) {
  let cadastrosPdf = formatarCadastrosComDoses(cadastros)
  let title_pdf = 'Dose Imunizante'
  let titlePdfSave = utils.methods.titlePdf(
    'Dose Imunizante',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Vacinas e doses preconizadas nos indicadores do PNI'

  // 1) Agora os "DADOS" viram COLUNAS
  const headers_pdf = [['CPF', 'CNS', 'NOME', 'NASCIMENTO', 'MÃE', 'MA']]

  // 2) Monta o body com 2 linhas por cadastro:
  //    - Linha de dados em colunas
  //    - Linha "container" (colSpan) para desenhar a tabela interna de doses
  const body = []

  for (let i = 0; i < cadastrosPdf.length; i++) {
    const c = cadastrosPdf[i]

    const cpf = c.nu_cpf ?? ''
    const cns = c.nu_cns ?? ''
    const nome = c.no_cidadao ?? ''
    const nasc = c.dt_nascimento
      ? utils.methods.formatDate(c.dt_nascimento) +
        ` (${
          c.idade_meses == 1 ? `${c.idade_meses} mês` : `${c.idade_meses} meses`
        })`
      : ''
    const mae = c.no_mae ?? ''
    const ma = c.micro_area ?? ''

    // colunas
    body.push([cpf, cns, nome, nasc, mae, ma])

    // célula única que vai receber a tabela interna
    body.push([
      {
        content: '', // não precisa texto
        colSpan: 7, // ocupa todas as colunas
        styles: {
          fillColor: '#f7f7f7',
          cellPadding: 1,
        },
        // guarda as doses aqui pra usar no didDrawCell
        _doses: c,
        _isDosesRow: true,
      },
    ])
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          { label: 'Equipe', value: selectEquipe.no_equipe },
          { label: 'CNES', value: selectEquipe.nu_cnes },
          { label: 'INE', value: selectEquipe.ine_esf_eap },
          { label: 'Microárea', value: microArea },
        ],
        verticalPosition
      )

      const pageWidth = doc.internal.pageSize.getWidth()
      const marginX = 15
      const tableWidth = pageWidth - marginX * 2

      doc.autoTable({
        head: headers_pdf,
        body,
        startY: verticalPosition,
        theme: 'striped',
        showHead: 'firstPage',
        margin: {
          left: marginX,
          right: marginX,
        },
        tableWidth: tableWidth,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 7,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },

        bodyStyles: {
          fontSize: 7,
          halign: 'center',
          cellPadding: 1,
        },

        // ajuste de largura das colunas
        columnStyles: {
          0: { cellWidth: 'auto' },
          1: { cellWidth: 'auto' },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 'auto' },
          4: { cellWidth: 'auto' },
          5: { cellWidth: 'auto' },
          6: { cellWidth: 'auto' },
        },

        // 3) Dá altura mínima na linha de doses pra caber o subtable
        didParseCell: function (data) {
          const raw = data.row.raw?.[0]
          if (raw && raw._isDosesRow && data.column.index === 0) {
            data.cell.styles.minCellHeight = 22 // ajuste fino conforme seu layout
          }
        },

        // 4) Desenha a tabela interna na linha de doses (colSpan)
        didDrawCell: function (data) {
          const raw = data.row.raw?.[0]
          if (!raw || !raw._isDosesRow) return
          if (data.column.index !== 0) return // só desenha 1x (na célula colSpan)

          const doses = raw._doses

          const val = (obj) =>
            obj != null && obj !== undefined
              ? `${obj.dt_plc.split('-').reverse().join('/')}`
              : ''

          const dosePneumococica = val(doses.dosePneumococica)
          const doseRotaVirus = val(doses.doseRotaVirus)
          const doseMeningococicaC = val(doses.doseMeningococicaC)
          const dosePenta = val(doses.dosePenta)
          const doseVip = val(doses.doseVip)
          const doseFebreAmarela = val(doses.doseFebreAmarela)
          const doseTripliceViral = val(doses.doseTripliceViral)
          const doseHepatiteA = val(doses.doseHepatiteA)

          // posiciona dentro da célula colSpan
          const x = data.cell.x + 0.5
          const y = data.cell.y + 1.5
          const w = data.cell.width - 1

          doc.autoTable({
            head: [
              [
                'PNEUMO 10V\n(D2)\n4 meses',
                'ROTA VÍRUS\n(D2)\n4 meses',
                'MENINGO C\n(D2)\n5 meses',
                'PENTA\n(D3)\n6 meses',
                'VIP\n(D3)\n6 meses',
                'F. AMARELA\n(D1)\n9 meses',
                'T. VIRAL\n(D1)\n12 meses',
                'HEPATITE A\n(D1)\n15 meses',
              ],
            ],
            body: [
              [
                dosePneumococica,
                doseRotaVirus,
                doseMeningococicaC,
                dosePenta,
                doseVip,
                doseFebreAmarela,
                doseTripliceViral,
                doseHepatiteA,
              ],
            ],
            startY: y,
            margin: { left: x },
            tableWidth: w,
            theme: 'grid',
            styles: {
              fontSize: 6.5,
              cellPadding: 1,
              halign: 'center',
              valign: 'middle',
            },
            headStyles: {
              fillColor: '#e6e6e6',
              textColor: '#000',
              fontSize: 6,
            },
          })
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

const formatDose = (dose) => {
  const dt = dose?.dt_plc
  if (!dt) return ''
  return dt.split('-').reverse().join('/')
}

export const dataFields = {
  Nome: 'no_cidadao',

  Nascimento: {
    callback: (item) => {
      return item.dt_nascimento != null
        ? `${utils.methods.formatDate(item.dt_nascimento)} (${
            item.idade_meses == 1
              ? `${item.idade_meses} mês`
              : `${item.idade_meses} meses`
          })`
        : ''
    },
  },

  Mãe: 'no_mae',
  MA: 'micro_area',
  'PNEUMO 10V (D2) 4 meses': {
    callback: (item) => formatDose(item.dosePneumococica),
  },

  'ROTA VÍRUS (D2) 4 meses': {
    callback: (item) => formatDose(item.doseRotaVirus),
  },

  'MENINGO C (D2) 5 meses': {
    callback: (item) => formatDose(item.doseMeningococicaC),
  },

  'PENTA (D3) 6 meses': {
    callback: (item) => formatDose(item.dosePenta),
  },

  'VIP (D3) 6 meses': {
    callback: (item) => formatDose(item.doseVip),
  },

  'FEBRE AMARELA (D1) 9 meses': {
    callback: (item) => formatDose(item.doseFebreAmarela),
  },

  'TRÍPLICE VIRAL (D1) 12 meses': {
    callback: (item) => formatDose(item.doseTripliceViral),
  },

  'HEPATITE A (D1) 15 meses': {
    callback: (item) => formatDose(item.doseHepatiteA),
  },
}
